import React, { createContext, useState, useEffect } from 'react';
import { useAuth } from './auth';
import Loader from '../components/FormsUI/Loader/index';
// Create Context
export const MenuAccessContext = createContext();

// Create a Provider component
export const MenuAccessProvider = ({ children }) => {
  const auth = useAuth();
  const [menuAccess, setMenuAccess] = useState();

  useEffect(() => {
    // Check sessionStorage
    const savedMenuAccess = sessionStorage.getItem('user')
      ? auth?.decoder(sessionStorage?.getItem('user'))
      : null;
    setMenuAccess(savedMenuAccess?.data?.UserInfo?.access);
  }, []);

   if (menuAccess === null) {
    return <Loader />; // or any loading spinner
  }

  return (
    <MenuAccessContext.Provider value={{ menuAccess, setMenuAccess }}>
      {children}
    </MenuAccessContext.Provider>
  );
};
